export const prepareHeaders = (headers, { getState }) => {
  const token = getState().user.access_token;
  const clientId = getState().user.client_id;
  const merchantId = getState().app.merchant.current;

  // If we have a token set in state, let's assume that we should be passing it.
  if (!headers.get('authorization') && token)
    headers.set('authorization', `Bearer ${token}`);
  if (clientId) headers.set('inc-client-id', clientId);
  if (merchantId) headers.set('inc-merchant-id', merchantId);

  return headers;
};
